export const riskControl_en = {
  title: `Establishing an authoritative, efficient, and humanistic risk control mechanism,
  Building a reliable and credible reputation cooperation risk protection system,
  Assisting customers looking for high-quality and long-term stable partners.`,
  riskMemberList: 'Risk Member list',
  riskSharing: 'Risk Sharing',
  riskPrevention: 'Risk Prevention',
  riskNotice: 'Risk Notice',
  riskControl: 'Risk Control Product',
  assuranceIntroduction: 'Assurance Introduction',
  hotTopics: 'Hot Topics',
  onlineClaim: 'Online Claim',
  resultTitle: 'Away from Risk!',
  backToRiskList: 'Back to Cooperation Risk Protection',
  riskRemind:
    'pls be reminded to check the membership status before cooperation with your partner, any suspended or blacklisted can not be covered by cooperation risk protection.',
  riskDescTitle:
    'Assisting customers looking for high-quality and long-term stable partners.',
  riskDescOneTitle: 'Online Acceptance',
  riskDescOne: 'Efficiently Handling Cases Of Members',
  riskDescTwoTitle: 'Dispute Coordination',
  riskDescTwo: 'Coordinating Disputes And Promoting Case Progress',
  riskDescThreeTitle: 'Risk Warning ',
  riskDescThree: 'Timely Detection And Disclosure Of Risk Members & Companies',
  riskDescFourTitle: 'Operatation standards',
  riskDescFour:
    'Share industry Standards And Operational Examples To Avoid Potential Risks',

  referralOffer: 'Risk control referral officer',
  riskCase: 'Risk Case',
  processInstructions: 'Process Instructions',
  compensationStandards: 'Protection Standards',
  questionAndHelp: 'Questions&Help',
  searchPlaceholder: 'Please enter the keyword',
  note: 'Note',
  noteTitle:
    'In addition to the membership status of the partner, the type of cooperation goods must also be consistent with the identity of the compensation will be paid.',
  example: 'Example',
  noteSubTitle:
    'JC Premium and JC Premium cooperation, cooperative goods for "general goods" can be compensated, cooperative goods for "dangerous goods" can not be compensated.',
  noteDesc:
    'The above is the maximum amount of protection, and the specific amount of protection shall be subject to the contract.',
}
export const riskControl_cn = {
  title: `建立权威、高效、有温度的风控机制，
  打造靠谱、有公信力的信誉保障体系，
  助力客户找到高质量且长期稳定的合作伙伴!`,
  riskMemberList: '风险名单',
  riskSharing: '风险分享',
  riskPrevention: '风险预防',
  riskNotice: '风险通知',
  riskControl: '风控产品',
  assuranceIntroduction: '规则介绍',
  hotTopics: '热门问题',
  onlineClaim: '线上申诉',
  resultTitle: '合作之前多来查查JCtrans！',
  backToRiskList: '返回合作保障',
  riskRemind:
    '提醒合作前请仔细检查合作方状态，存在任何暂停或者黑名单标识的会员均不享受平台保障权益',
  riskDescTitle: '助力客户之间找到更高质量且长期稳定的合作伙伴',
  riskDescOneTitle: '线上受理',
  riskDescOne: '高效处理平台会员的案件',
  riskDescTwoTitle: '纠纷协调',
  riskDescTwo: '协调纠纷并推进案件进程',
  riskDescThreeTitle: '风险预警',
  riskDescThree: '及时发现并公示风险会员&企业',
  riskDescFourTitle: '操作规范',
  riskDescFour: '分享行业规范&操作实例，规避潜在风险',

  referralOffer: '风控推荐官',
  riskCase: '案例解析',
  processInstructions: '规则说明',
  compensationStandards: '保障标准',
  questionAndHelp: '问题&帮助',
  searchPlaceholder: '请输入关键字',
  note: '温馨提示',
  noteTitle: '除了看合作方会员身份，合作的货物类型也需与身份相符才享受平台保障',
  example: '例',
  noteSubTitle:
    'JC Premium与JC Premium合作，合作货物为“普货”可以享受保障，合作货物为“危险品”则无法享受保障',
  noteDesc: '以上为保障金额最高上限，具体保障金额按照合同约定为准',
}
